import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Configuration, UserCredentials, RecipeFilter, Category, CategoryProduct, ServerResponse } from '../models';
import { AccountService } from './account.service';
import { AppConfig } from './app.config';
import { RestService } from './rest.service';

@Injectable()
export class CategoryService {

  constructor(
    private restService: RestService,
    private accountService: AccountService
  ) {
    this.Config = AppConfig.config;
  }

  private Config: Configuration;

  private requestOptions = new RecipeFilter();
  private categoriesSubject = new BehaviorSubject<Category[]>(null);
  private categories: Category[];
  private requestOptionsProducts = new RecipeFilter();
  private categoriesProductsSubject = new BehaviorSubject<CategoryProduct[]>(null);
  private categoriesProducts: CategoryProduct[];
  private isLoading = false;

  private refresh(): void {
    if (this.isLoading) {
      return;
    }
    this.accountService.getCredentialsPromise().then(cred => {
      this.isLoading = true;
      this.requestOptions.Id_session = cred.Id_Session;
      this.requestOptions.Id_app = this.Config.AppId;
      this.requestOptions.ManualJSON = 0;
      this.requestOptions.PageSize = 1000;
      this.requestOptions.Controller0 = 'dictionary';
      this.requestOptions.Section = 'CategoryRecipe';
      this.requestOptions.Method = 'Print';
      this.requestOptions.ApiVersion = 'v1';

      this.restService.get(
        this.requestOptions).then(x => {
          if (x !== null) {
            this.isLoading = false;
            const response: ServerResponse<Category> = x;
            this.categories = response.Result.Resultset;
            this.categoriesSubject.next(this.categories);
          }
        });
    });
  }

  public get(forceUpdate = false): Observable<Category[]> {
    if (forceUpdate || !this.categories) {
      this.refresh();
    }

    return this.categoriesSubject.asObservable();
  }

  private refreshProducts(): void {
    this.accountService.getCredentialsPromise().then(cred => {
      this.requestOptionsProducts.Id_session = cred.Id_Session;
      this.requestOptionsProducts.Id_app = this.Config.AppId;
      this.requestOptionsProducts.ManualJSON = 0;
      this.requestOptionsProducts.PageSize = 1000;
      this.requestOptionsProducts.Controller0 = 'dictionary';
      this.requestOptionsProducts.Section = 'CategoryProduct';
      this.requestOptionsProducts.Method = 'Print';
      this.requestOptionsProducts.ApiVersion = 'v1';

      this.restService.get(
        this.requestOptionsProducts).then(categories => {
          if (categories !== null) {
            const response: ServerResponse<CategoryProduct> = categories;
            this.categoriesProducts = response.Result.Resultset;
            this.categoriesProductsSubject.next(this.categoriesProducts);
          }
        });
    });
  }

  public getProductsCategory(): Observable<CategoryProduct[]> {
    if (!this.categoriesProducts) {
      this.refreshProducts();
    }

    return this.categoriesProductsSubject.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/category.service.ts